import { SimpleDefinitionListItem } from "@components"
import { mySqlToLocal } from "@helpers"
import { DocumentIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const MetaDetails = ({ backButton, event }) => (
  <div>
    <div className="mb-6">
      <SimpleDefinitionListItem caption="Event ID" description={event.id} icon={<DocumentIcon />} />
      <SimpleDefinitionListItem caption="Created By" description={`${event.user?.name}`} icon={<DocumentIcon />} />
      <SimpleDefinitionListItem caption="Contact Email" description={event.user?.email ?? "Unknown"} icon={<DocumentIcon />} />
      <SimpleDefinitionListItem caption="Created At" description={mySqlToLocal(event.created_at).format("DD MMM YYYY, H:mm")} icon={<DocumentIcon />} showBorder={false} />
    </div>

    {backButton}
  </div>
)

MetaDetails.propTypes = {
  backButton: PropTypes.element.isRequired,
  event: PropTypes.object.isRequired,
}

export default MetaDetails